interface IFooterSectionProps {
    children?: React.ReactNode | React.ReactNode[]
    title: string | React.ReactNode
}

export const FooterSection = ({ children, title }: IFooterSectionProps) => {
    return (
        <div className="flex flex-col w-[200px] md:w-[153px] lg:w-[200px] xl:w-[240px] px-5 md:items-center ">
            <div className="flex flex-col w-fit">
                <h6 className="text-black/40 mb-2 uppercase tracking-widest font-medium text-[12px]">
                    {title}
                </h6>

                <div className="flex flex-col gap-y-4">{children}</div>
            </div>
        </div>
    )
}
